module.exports = __webpack_public_path__ + "static/media/delete_grey.f74e8015.svg";